import { Component, Inject, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { MaintenanceType, Recurrence, RecurrenceDialogData } from '@interfaces';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { filter, take } from 'rxjs/operators';
import { fade } from '../../../../../core/animations/fade.animation';
import english from '../../../i18n/en.json';
import spanish from '../../../i18n/es.json';
import portuguese from '../../../i18n/pt.json';

@Component({
  selector: 'tab-general',
  templateUrl: './tab-general.component.html',
  styleUrls: ['./tab-general.component.scss'],
  animations: [fade]
})
export class TabGeneralComponent implements OnInit {

  @Input()
  public recurrenceForm: FormGroup;

  @Input()
  public maintenanceTypes: MaintenanceType[];

  public isUpdate = false;

  public minDate = moment().startOf('day');

  public ifDayNotExistsAllMonths = false;
  public recurrence: Recurrence;
  public isViewMode: boolean;
  public hasSegmentSelected: boolean;
  public isFromSateAdjusted: boolean;

  public repeatOptions = [
    {
      text: this.translateService.instant('RECURRENCES.INTERVAL.DAILY'),
      value: 'daily',
    },
    {
      text: this.translateService.instant('RECURRENCES.INTERVAL.WEEKLY'),
      value: 'weekly',
    },
    {
      text: this.translateService.instant('RECURRENCES.INTERVAL.MONTHLY'),
      value: 'monthly',
    }
  ];

  public weekdayOptions = [
    {
      text: this.translateService.instant('RECURRENCES.WEEKDAY.MONDAY'),
      value: 'monday',
    },
    {
      text: this.translateService.instant('RECURRENCES.WEEKDAY.TUESDAY'),
      value: 'tuesday',
    },
    {
      text: this.translateService.instant('RECURRENCES.WEEKDAY.WEDNESDAY'),
      value: 'wednesday',
    },
    {
      text: this.translateService.instant('RECURRENCES.WEEKDAY.THURSDAY'),
      value: 'thursday',
    },
    {
      text: this.translateService.instant('RECURRENCES.WEEKDAY.FRIDAY'),
      value: 'friday',
    },
    {
      text: this.translateService.instant('RECURRENCES.WEEKDAY.SATURDAY'),
      value: 'saturday',
    },
    {
      text: this.translateService.instant('RECURRENCES.WEEKDAY.SUNDAY'),
      value: 'sunday',
    }
  ];

  constructor(
    @Inject(MAT_DIALOG_DATA) public readonly recurrenceDialogData: RecurrenceDialogData,
    private readonly fuseTranslationLoaderService: FuseTranslationLoaderService,
    private readonly translateService: TranslateService
  ) {
    this.recurrence = this.recurrenceDialogData.recurrence;
    this.isViewMode = this.recurrenceDialogData.isViewMode;
    this.isUpdate = !!this.recurrence && !!this.recurrence.id;
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
  }

  skipWeekendChange(): void {
    this.recurrenceForm.get('weekday').setValue('monday');
  }

  ngOnInit(): void {
    this.adjustFromDate();
  }


  adjustFromDate(): void {
    if (!this.recurrenceDialogData.isCopyMode) { return; }

    const from = moment(this.recurrenceForm.get('from').value);

    if (from.isSameOrAfter(this.minDate)) { return; }

    this.recurrenceForm.get('from').setValue(this.minDate);
    this.isFromSateAdjusted = true;

    this.recurrenceForm.get('from').valueChanges.pipe(
      filter(() => this.isFromSateAdjusted),
      take(1)
    ).subscribe(() => {
      this.isFromSateAdjusted = false;
    });
  }
}
